import { API_BASE_URL } from '@src/globals';
import { FLM_ROUTE_MASTER_PARAMS } from 'src/components/pages/OpsDashboard/Setup/TransportModule/FlmRoute/FlmRouteMaster.constants';
import { DOWNLOAD_SAMPLE_FLM_ROUTE_MASTER, FETCH_FLM_ROUTE_MASTER, DOWNLOAD_FLM_ROUTE_MASTER, BULK_CREATE_FLM_ROUTE_MASTER, BULK_UPDATE_FLM_ROUTE_MASTER } from './routes';
import { GET, POST } from './apiHandler';
import { morphism } from 'morphism';
import { 
    requestModelFlmRoute, 
    responseModelFlmRoute,
    responseModelSingleFlmRouteManage
} from '../model/consignmentView';
import { mergeMultiSheetData } from './utils';


export const fetchAllFlmRoutes = async(params = {}) => {
    const body = {
      ...morphism(requestModelFlmRoute, params),
    };

    const response = await POST(`${API_BASE_URL}${FETCH_FLM_ROUTE_MASTER}`, body);

    return {
      ...morphism(responseModelFlmRoute, response),
    };
};

export const addMultipleFlmRoutes = async(body) => {
    let routes = [];
    if (body.Routes && body.Route_List) {
        const routesSheet = body.Routes || [];
        const routeListSheet = body.Route_List || [];
        routes = mergeMultiSheetData(routesSheet, routeListSheet);
    }
    const requestBody = {
        [FLM_ROUTE_MASTER_PARAMS]: routes
    };
    
    const response = await POST(`${API_BASE_URL}${BULK_CREATE_FLM_ROUTE_MASTER}`, requestBody);
    return {
        ...morphism(responseModelSingleFlmRouteManage, response),
    };
};

export const updateMultipleFlmRoutes = async(body) => {
    let routes = [];
    if (body.Routes && body.Route_List) {
        const routesSheet = body.Routes || [];
        const routeListSheet = body.Route_List || [];
        routes = mergeMultiSheetData(routesSheet, routeListSheet);
    }
    const requestBody = {
        [FLM_ROUTE_MASTER_PARAMS]: routes
    };
    
    const response = await POST(`${API_BASE_URL}${BULK_UPDATE_FLM_ROUTE_MASTER}`, requestBody);
    return {
        ...morphism(responseModelSingleFlmRouteManage, response),
    };
};


export const generateSampleFlmRouteExcelForBulkAction = async (params = {}) => {
    return GET(`${API_BASE_URL}${DOWNLOAD_SAMPLE_FLM_ROUTE_MASTER}`, params, 'blob');
};

export const updateSingleFlmRoute = async (body) => {
    const parsedInput = {
        [FLM_ROUTE_MASTER_PARAMS]: [body],
    };
    const response = await POST(`${API_BASE_URL}${BULK_UPDATE_FLM_ROUTE_MASTER}`, parsedInput);
    return {
        ...morphism(responseModelSingleFlmRouteManage, response),
    };
};



export const downloadFlmRoutes = async (body) => {
    return GET(`${API_BASE_URL}${DOWNLOAD_FLM_ROUTE_MASTER}`, body);
};